export default __webpack_public_path__ + "static/media/requisition-link-icon.06b74521.svg";